import { render } from "./SalesReturnReportPage.vue?vue&type=template&id=4e260e3f&scoped=true&ts=true"
import script from "./SalesReturnReportPage.vue?vue&type=script&lang=ts"
export * from "./SalesReturnReportPage.vue?vue&type=script&lang=ts"

import "./SalesReturnReportPage.vue?vue&type=style&index=0&id=4e260e3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e260e3f"]])

export default __exports__